export default {"src":"/_next/static/media/stethoscopeLine.f72afd29.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};